import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"

import Container from "../components/grid/Containter"
import { Helmet } from 'react-helmet'
import Layout from "../components/Layout"
import Row from "../components/grid/Row"
import { generalData } from '../structuredData'
import { useLocation } from '@reach/router'

const PageNotFound: React.FC = () => {
  const { origin } = useLocation()

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "header-4.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1960) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  const imageData = useMemo(() => {
    return {
      src: data.file.childImageSharp.fluid.src,
      width: 1960,
      height: 500,
    }
  }, [data])

  return (
    <Layout>
      <Helmet>
        <script type="application/ld+json">
          {generalData(origin, imageData.src)}
        </script>
      </Helmet>
      <Container>
        <Row>
          <p>Page not found</p>
        </Row>
      </Container>
    </Layout>
  )
}

export default PageNotFound
